import React, { useState, useEffect } from 'react';
import api                            from './AxiosConfig';
import DisplayStatusDXYRow             from './DisplayStatusDXYRow';

function ReviewGoalDXY( props ) {
  const date = require('date-and-time'); 
  const [progress, setProgress ] = useState();
  const [loaded,   setLoaded   ] = useState( false );
  const [records,  setRecords  ] = useState();
  
  useEffect(() => {
      const getGoalProgress = async () => {
        if ( props && props.goal && props.goal.id && !loaded) {
            // Fetch the goal from the backend using axios
            try {
                const goalProgress = await api.get(`/site/goals/progress/${encodeURIComponent(props.goal.id)}`, {withCredentials: true });
                setProgress( goalProgress.data );
                setLoaded( true );
            } catch (error) {
                console.log("ReviewGoalDXY: " + error);
            }
        }
    }
    getGoalProgress();
  }, [loaded, props]); 

  useEffect(() => {
      const mapProgress = async () => {
          if (loaded && progress && progress.length > 0) {
              var d = 0;
              var recs    = [];
              var subrecs = [];
              for (const el of progress) {
                  if ( d === 0 ) {
                      var ds = date.format(new Date(el.date), "DD/MM");
                      subrecs = [];
                  }
                  subrecs.push( { mz: el.is_measured === 1, sc: el.score } );
                  if ( d === 6 ) {
                      recs.push( { ds: ds, subrecs: subrecs } );
                  }
                  d = d + 1;
                  if ( d === 7 ) { d = 0; }
              }
              setRecords( recs );
          }
      }

      mapProgress();
  }, [progress, loaded, date]);
  
    
 return (
  <div>
    {props && props.goal ? (
      <>
        {records ? (
          <>
            {records.map((r, index) => (
              <div class="left-content d-flex"><div class="dcdate">{r.ds}</div><DisplayStatusDXYRow key={index} row={r.subrecs}/> </div>
            ))}
          </>
        ) : (
          <>Loading...</>
        )}
      </>
    ) : (
      <p>No PS Goal received.</p>
    )}
  </div>
);
}

export default ReviewGoalDXY;
